import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "redux/services/apiCall";
import { API_CATEGORY } from "redux/services/apiTypes";

interface StaffListState {
  categoryListLoading: boolean;
  categoryListSuccess: boolean;
  categoryListRes: any;
  categoryListErr: unknown | null;
}

const initialState: StaffListState = {
  categoryListLoading: false,
  categoryListSuccess: false,
  categoryListRes: null,
  categoryListErr: null,
};

const categoryListSlice = createSlice({
  name: "categoryList",
  initialState,
  reducers: {
    clearCategory: (state) => {
      state.categoryListLoading = false;
      state.categoryListSuccess = false;
      state.categoryListRes = null;
      state.categoryListErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryList.pending, (state) => {
        state.categoryListLoading = true;
        state.categoryListSuccess = false;
      })
      .addCase(getCategoryList.fulfilled, (state, action) => {
        state.categoryListLoading = false;
        state.categoryListSuccess = true;
        state.categoryListRes = action.payload;
      })
      .addCase(getCategoryList.rejected, (state, action) => {
        state.categoryListLoading = false;
        state.categoryListSuccess = true;
        state.categoryListErr = action.payload;
      });
  },
});

export const getCategoryList = createAsyncThunk(
  categoryListSlice.name,
  async (
    payload: {
      query?: string;
    },
    { fulfillWithValue, rejectWithValue }
  ) => {
    const apiData = {
      type: payload?.query ? `${API_CATEGORY}${payload.query}` : API_CATEGORY,
      apiType: "GET",
    };
    try {
      const res = await apiCall(apiData);
      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const { clearCategory } = categoryListSlice.actions;

export default categoryListSlice.reducer;
